import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'views/components/ui-component/Loadable';
import MinimalLayout from 'views/components/layout/MinimalLayout';

const UserLogin = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserLoginForm')));
const UserInfo = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserInfo')));
const UserEdit = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserEdit')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'auth/login',
            element: <UserLogin />
        }
    ]
};

export default AuthenticationRoutes;
